import getIssueType, { ISSUE_FILTER_TYPES } from 'utils/getIssueType';
import { Issue } from './api.types';
import sortLocalElections, { SortedIssue } from './sortLocalElections';

const sortPollDay = (issues: Issue[]): Issue[] => {
  const localElections: SortedIssue[] = [];

  const sortedIssues = issues
    .map((issue) => {
      const issueType = getIssueType(issue.info);
      switch (issueType) {
        case ISSUE_FILTER_TYPES.poll:
          if (issue.info.scope === 'federal') {
            return {
              ...issue,
              sortKey: 1,
            };
          }
          return {
            ...issue,
            sortKey: 2,
          };
        case ISSUE_FILTER_TYPES.nationalCouncil:
          return {
            ...issue,
            sortKey: 3,
          };
        case ISSUE_FILTER_TYPES.grossRat:
          return {
            ...issue,
            sortKey: 4,
          };
        case ISSUE_FILTER_TYPES.governmentCouncil:
          if (issue.info.title.de.toLowerCase().includes('regierungsrat')) {
            return {
              ...issue,
              sortKey: 6,
            };
          }
          return {
            ...issue,
            sortKey: 5,
          };
        default:
          return {
            ...issue,
            sortKey: 7,
          };
      }
    })
    .sort((a, b) => {
      if (a.sortKey < b.sortKey) return -1;
      if (a.sortKey > b.sortKey) return 1;
      return 0;
    })
    .map((sortedIssue) => {
      // we remove local elections and store them in a separate array
      // these are sorted seperatedly depending on district name and roman numbers
      if (sortedIssue.sortKey === 7) {
        localElections.push(sortedIssue);
        return null;
      }
      const copyOfIssue = { ...sortedIssue };
      delete copyOfIssue.sortKey;
      return copyOfIssue;
    })
    .filter((issue) => issue !== null);

  const sortedLocalElections = sortLocalElections(localElections);

  return [...sortedIssues, ...sortedLocalElections];
};

export default sortPollDay;
